import React, { useState, useLayoutEffect, useContext } from 'react'
import { TableDataContext } from '../index';
import { escapeCsv, formatDateToMMDDYYYY, formatDateToUsaMMDDYYYY, trackingHandle } from '../../../JS/Common';
import TrackingDetailsPopup from '../../../Components/TrackingDetailsPopup';
export default function IncomingBatch(props) {
    const [loadData, setLoadData] = useState({ data: [], show: false })
    const { AllDashBoardData } = useContext(TableDataContext);
    const initialTrackSate = {
        show: false,
        BatchId: null
    }
    const [showTrackingModal, setShowTrackingModal] = useState(initialTrackSate);

    useLayoutEffect(() => {
        if (AllDashBoardData?.incomingBatch?.data?.length > 0) {
            let Data = AllDashBoardData?.incomingBatch?.data
            if (Data?.length > 20) {
                setLoadData({ ...loadData, data: [].concat(Data?.slice(0, 20)) })
            } else {
                setLoadData({ ...loadData, data: Data })
            }
        }
    }, [AllDashBoardData?.incomingBatch?.data])
    const LoadMore = () => {
        let newData = []
        if (loadData?.data?.length != AllDashBoardData?.incomingBatch?.data?.length) {
            newData = loadData?.data?.concat(AllDashBoardData?.incomingBatch?.data?.slice(loadData?.data?.length, loadData?.data?.length + 20));
        } else {
            newData = [].concat(AllDashBoardData?.incomingBatch?.data?.slice(0, 20))
        }
        setLoadData({ ...loadData, data: newData });
    }

    const downloadCsv = () => {
        const csvContent = [];
        const rowCollection = [];
        AllDashBoardData?.incomingBatch?.data?.forEach((ticket) => {
            const rowData = {
                'Batch Name': escapeCsv(ticket.batch_name),
                'Total Devices': ticket?.unique_logs ? ticket?.unique_logs[0]?.unique_ticket_count : ticket?.unique_ticket_count || "0",
                'Created Date': ticket?.created_at ? formatDateToUsaMMDDYYYY(ticket?.created_at) : '-',
                'Tracking Number': ticket?.tracking_num || '-',
            };
            rowCollection.push(rowData);
        });
        const headers = ['Batch Name', 'Total Devices', 'Created Date', 'Tracking Number'];
        csvContent.push(headers);

        // Add data rows
        rowCollection.forEach((rowData) => {
            const values = headers.map((h) => rowData[h]);
            csvContent.push(values);
        });
        const csvString = csvContent.map(row => row.join(',')).join('\n');
        const blob = new Blob([csvString], { type: 'text/csv' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'outgoing_batch_report.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    return (
        <React.Fragment>
            <div className="col-12  greyBoxShadow" style={{ height: "100%" }}>
                <div className="pb-5 w-100">
                    <div className="row mt-2 px-2 time" >
                        <div className='Header col-md-8'>
                            <b className='font-15'>Outgoing Batches</b><br />
                        </div>
                        <div className='col-md-4 text-end'>
                            <b className='cursor-pointer text-decoration-underline' onClick={downloadCsv}>Download CSV</b>
                        </div>
                    </div>
                    <hr className="my-2" />
                    {AllDashBoardData?.incomingBatch?.loader ? <div className='row'><div className="col-12 text-center pt-2"><img src="/images/loder.svg" className="" style={{ width: "30px" }} /></div></div> : <>
                        <table className="table data-table">
                            <thead className='GridHeader'>
                                <tr>

                                    <th scope="col" className='fw-600 font-14'>Batch Name</th>
                                    <th scope="col" className='fw-600 font-14' >Devices</th>
                                    <th scope="col" className='fw-600 font-14' >Tracking #</th>
                                </tr>
                            </thead>
                            <tbody>
                                {AllDashBoardData?.incomingBatch?.data?.length > 0 ?
                                    loadData?.data?.map((data, i) => (
                                        <tr className='OddEvenClass tableBorderHide py-3' key={data?.id}>
                                            <td className='location-name' title={data?.batch_name}>{data?.batch_name}</td>
                                            <td>{data?.unique_logs ? data?.unique_logs[0]?.unique_ticket_count : data?.unique_ticket_count || "0"}</td>
                                            <td className='py-12 cursor-pointer' title="Show Tracking Information">{data.tracking_num != null ? <u onClick={(e) => setShowTrackingModal(prev => ({ ...prev, show: true, BatchId: data?.id }))}>{data.tracking_num}</u> : <>-</>}</td>

                                        </tr>
                                    )) :
                                    <tr className='OddEvenClass tableBorderHide py-3'>
                                        <td colSpan={3} className='text-center'> No Record Found</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </>}

                    {
                        AllDashBoardData?.incomingBatch?.data?.length > 20 && <div className="col-12 p-2 admin-table-border-top">
                            <span style={{ textDecoration: "underline", cursor: "pointer", color: "var(--primary-color)" }} onClick={() => LoadMore()}> {loadData?.data?.length == AllDashBoardData?.incomingBatch?.data?.length ? "Hide" : "Load More"}</span>
                        </div>
                    }
                </div>
            </div>
            {showTrackingModal.show && (
                <TrackingDetailsPopup showModal={showTrackingModal.show} closePopup={() => setShowTrackingModal(initialTrackSate)} BatchId={showTrackingModal.BatchId} />
            )}
        </React.Fragment>
    )
}
